import {
  MissingProductDescriptionErrorForm,
  MissingProductReferentialErrorForm,
} from 'components/common-form/MissingProductDescriptionErrorForm';
import { useProductFormGuard } from 'components/common-form/product-form-guard/use-product-form-guard';
import { FormLoadingIndicator } from 'components/shared/FormLoadingIndicator/FormLoadingIndicator';
import type { ReactNode } from 'react';

export function ProductsFormGuard({ children }: { children: ReactNode }) {
  const guardState = useProductFormGuard();

  if (guardState.isProductsDescriptionLoading || guardState.isProductsReferentialLoading) {
    return <FormLoadingIndicator className="w-100 justify-content-center align-items-center mt-0 h-100" />;
  }

  if (guardState.isProductsDescriptionError) {
    return <MissingProductDescriptionErrorForm onReload={guardState.onReloadProductDescriptions} />;
  }

  if (guardState.isProductsReferentialError) {
    return <MissingProductReferentialErrorForm onReload={guardState.onReloadProductReferential} />;
  }

  return children;
}
